import { config } from '../../Config';

const CreateChat = async (userId, extensionId = "DONA") => {
    const url = config.createChat;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ userId, extensionId })
        });

        if (!response.ok) {
            throw new Error(`Failed to create chat: ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        // console.error('Error creating chat:', error);
        return null;
    }
};

export default CreateChat;
